import axios from "axios";
import { API_BASE_URL } from "../components/constant/ApiConstant";

export const apiRequest = async ({
  method,
  url,
  data = {},
  params = {},
  headers = {},
  useBaseUrl = true,
}) => {
  try {
    const baseURL = useBaseUrl ? API_BASE_URL : "";
    const accessToken = localStorage.getItem("accessToken");
    const instance = axios.create({
      baseURL,
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken}` : "",
        ...headers,
      },
    });

    const response = await instance.request({
      method, // HTTP method (GET, POST, PUT, DELETE, etc.)
      url, // API endpoint
      data, // Body payload (for POST, PUT, PATCH)
      params, // Query parameters
    });

    return response.data;
  } catch (error) {
    return {
      status: error.response?.status || 400,
      message: error.response?.data?.message || error.message,
    };
  }
};
